// extracted by mini-css-extract-plugin
export default {"wrapper":"BlO7VlCHCUa4dNttXZDh","rule":"oyZjqsg6TMI_7Y078mWK","title":"beahcktaZDlngdSTsBug","text":"urMPUSopbWI1qkD816MJ","highlightedText":"_FgK7nVCAmJIJT9KM3i1"};